<template>
  <div :class="$style.layout">
    <div :class="$style.main"
         ref="main">
      <div :class="$style.left"
           :style="leftStyle">
        <slot></slot>
      </div>
      <div :class="$style.right">
        <slot name="right"></slot>
      </div>
    </div>
    <div ref="top"
         :class="$style.top"
         @click="onCollapseTop()">
      <order-review-layout-panel :style="topStyle">
        <slot name="top"></slot>
      </order-review-layout-panel>
    </div>
  </div>
</template>

<script>
import OrderReviewLayoutPanel from '@views/order-review/pages/OrderReviewLayoutPanel'

export default {
  components: {OrderReviewLayoutPanel},
  props: {},
  data () {
    return {
      maxTopHeight: null,
      minTopHeight: 85,
      collapseTop: false,
    }
  },
  computed: {
    height () {
      if (this.collapseTop) {
        return this.minTopHeight
      } else {
        if (this.maxTopHeight) {
          return this.maxTopHeight - 10
        }
        return this.maxTopHeight
      }
    },
    leftStyle () {
      if (this.height) {
        return `margin-top: ${this.height}px;`
      }
    },
    topStyle () {
      let style = 'margin-bottom: 0;position: relative;overflow: hidden;'
      if (this.collapseTop) {
        return style + `height: ${this.minTopHeight - 10}px;`
      }
      return style
    },
  },
  watch: {},
  created () { },
  mounted () {
    this.$refs.main.addEventListener('scroll', this.mainScroll)
  },
  updated () {
    if (this.maxTopHeight !== this.$refs.top.offsetHeight) {
      this.maxTopHeight = this.$refs.top.offsetHeight
    }
  },
  destroyed () {},
  methods: {
    onCollapseTop (value) {
      if (typeof value === 'boolean') {
        this.collapseTop = value
      } else {
        this.collapseTop = false
      }
      this.$emit('collapse', this.collapseTop)
    },
    mainScroll () {
      this.onCollapseTop(true)
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
.layout {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.top {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 330px);
  padding: 10px;
  background-color: #eff0f4;
}

.main {
  overflow-x: hidden;
  overflow-y: scroll;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 20px);
  box-sizing: border-box;
  margin: 10px 0;
  padding: 0 10px;

  .left {
    width: calc(100% - 300px);
  }

  .right {
    position: fixed;
    top: 60px;
    right: 10px;
    height: calc(100% - 90px);
    width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewLayout.vue